import { Divider, Flex, type FlexProps, Text } from '@shared/components';
import { Fragment } from 'react';

import { SummaryItem, type SummaryItemProps } from '../summary-item';

export interface SummaryCardProps extends FlexProps {
  title: string;
  items: SummaryItemProps[];
}

export default function SummaryCard(props: Readonly<SummaryCardProps>) {
  const { title, items, ...restProp } = props;

  return (
    <Flex
      {...restProp}
      sx={(theme) => ({
        backgroundColor: theme.palette.primary.lighter,
        p: theme.spacing(3, 4),
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(4),
        flex: 1,
      })}
    >
      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(3), flex: 1 }}>
        <Text variant='body2Semibold' sx={{ fontWeight: 600 }}>
          {title}
        </Text>
        <Flex sx={{ gap: (theme) => theme.spacing(4), flex: 1 }}>
          {items.map((item, index) => {
            const key = `${item.title}`;
            return (
              <Fragment key={key}>
                <SummaryItem {...item} />
                {index < items.length - 1 ? (
                  <Divider
                    orientation='vertical'
                    sx={{ height: '24px', display: 'flex', alignSelf: 'center' }}
                    flexItem
                  />
                ) : null}
              </Fragment>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
}
